import { Form, Input, Select } from "antd";
import React, { useEffect } from "react";
import CustomUploader from "../../../../components/CustomUpload/CustomUploader";
import { useContext } from "react";
import ExpertVideosContext from "../../../../context/expertVideosContext";
import TextArea from "antd/es/input/TextArea";

function ExpertVideoModal({ video }) {




  const { keywords, titleAction, descriptionAction, tagAction, categoriesIdsAction, keywordsAction } = useContext(
    ExpertVideosContext
  );

  useEffect(() => {
    if (video) {
      titleAction(video?.title);
      descriptionAction(video?.description);
      tagAction(video?.tag);
      categoriesIdsAction(video?.categoriesIds)
      keywordsAction(video?.keywords)
    }
  }, [video]);

  const setTag = (e) => {
    tagAction(e.target.value)
  }

  const setCategoriesIds = (ctgIds) => {
    categoriesIdsAction(ctgIds)
  }

  const setKeywords = (keywords) => {
    keywordsAction(keywords)
  }

  return (
    <div>
      <Form layout="vertical">
        <div className="flex flex-row max-lg:flex-col justify-between gap-3">
          <section className="flex flex-col justify-between max-lg:w-full w-1/2">
            <Form.Item label="عنوان ویدئو:">
              <Input
                className="text-xs rounded-lg  border-none"
                placeholder="عنوان را وارد کنید..."
                onChange={(e) => titleAction(e.target.value)}
                defaultValue={video?.title}
              />
            </Form.Item>
            <Form.Item label="توضیحات:">
              <TextArea
              style={{height:'120px'}}
                className="justify-start text-xs h-[97px]  border-none"
                placeholder="توضیحات خود را وارد کنید..."
                onChange={(e) => descriptionAction(e.target.value)}
                defaultValue={video?.description}
              />
            </Form.Item>
            <Form.Item label="نوع ویدیو:">
            <div className="w-[130px] h-7 py-1 mx-1 px-1 bg-blue-700 rounded-xl justify-between items-center gap-2.5 inline-flex">  
            <input name="video-type" type="radio" value="EDUCATIONAL_VIDEO" className="h-5 w-5" defaultChecked={video?.tag === "EDUCATIONAL_VIDEO"} onChange={setTag}/>
            <span className="text-sm text-white">ویدیو آموزشی</span>
            </div >
            <div className="w-[130px] h-7 py-1 mx-1 px-1 bg-green-700 rounded-xl justify-between items-center gap-2.5 inline-flex">  
            <input name="video-type" type="radio" value="FARMER_EXPERIENCE" className="h-5 w-5" defaultChecked={video?.tag === "FARMER_EXPERIENCE"} onChange={setTag}/>
            <span className="text-sm text-white">تجربه کشاورزان</span>
            </div>
            </Form.Item>
            {/* <Form.Item label="دسته بندی ویدئو:">
            <Select
              options={products}
              mode="multiple"
              onChange={setCategoriesIds}
              optionLabelProp="label"
              style={{ width: "100%" }}
              placeholder="     --دسته بندی--"
              defaultValue={video?.categoriesIds}
            />
            </Form.Item> */}
        
            <Form.Item label="کلمات کلیدی:">
            <Select
              options={keywords}
              mode="tags"
              onChange={setKeywords}
              optionLabelProp="label"
              style={{ width: "100%" }}
              placeholder="     کلمات کلیدی. . . + ENTER"
              defaultValue={video?.keywords}
            />
            </Form.Item>
            
          </section>
          <section className="flex flex-col w-1/2 max-lg:w-full items-end">
            <Form.Item className="text-center w-full shadow rounded-lg p-3 ">
              <CustomUploader type="video" files={video?.files ? video?.files : null}/>
            </Form.Item>
            <Form.Item className="text-center w-full shadow rounded-lg p-3 ">
              <CustomUploader type="video-cover" files={video?.cover ? [video?.cover] : null}/>
            </Form.Item>
          </section>
        </div>
      </Form>
    </div>
  );
}

export default ExpertVideoModal;
